module.exports = __webpack_public_path__ + "img/cloud-rain-moon.fbc6a627.svg";